// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2w47D","subheader":"ReorderModal_subheader__3UFRe","listWrap":"ReorderModal_listWrap__1QaWa"};